var AV = require('leancloud-storage')

AV.init({
    appId: 'Qjq6GiOHk16Q2hNrXudEyc51-MdYXbMMI',
    appKey: 'nvuPu8uoOmvK8gO47dqcA4hU'
})

export default AV